import { render, staticRenderFns } from "./MypageTicketPageWrapper.vue?vue&type=template&id=d5ae9386"
import script from "./MypageTicketPageWrapper.vue?vue&type=script&lang=ts"
export * from "./MypageTicketPageWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports